import InputNumber from './src';

export default {
  install(Vue) {
    Vue.component('DInputNumber', InputNumber);
  }
};
